import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from "../../pages/home/home.component";
import {LoginComponent} from "../../pages/login/login.component";
import {NotFoundComponent} from "../components/not-found/not-found.component";
import {UsuarioComponent} from "../../pages/usuario/usuario.component";
import {PlanoComponent} from "../../pages/plano/plano.component";
import {ExecucaoPlanoComponent} from "../../pages/execucao-plano/execucao-plano.component";
import {PlanosComponent} from "../../pages/planos/planos.component";
import {GerencialPlanoComponent} from "../../pages/gerencial-plano/gerencial-plano.component";
import {ConsultarMinutaComponent} from "../../pages/consultar-minuta/consultar-minuta.component";
import {EsqueciMinhaSenhaComponent} from "../../pages/esqueci-minha-senha/esqueci-minha-senha.component";
import {PerfilComponent} from "../../pages/perfil/perfil.component";
import {UsuariosComponent} from "../../pages/usuarios/usuarios.component";
import {LoginExternoComponent} from "../../pages/login-externo/login-externo.component";
import {CadastroExternoComponent} from "../../pages/cadastro-externo/cadastro-externo.component";
import {UsuarioExternoComponent} from "../../pages/usuario-externo/usuario-externo.component";
import {AvaliarCadastroExternoComponent} from "../../pages/avaliar-cadastro-externo/avaliar-cadastro-externo.component";
import {VisualizarCadastroExternoComponent} from "../../pages/visualizar-cadastro-externo/visualizar-cadastro-externo.component";
import {DevComponent} from "../../dev-component";
import {CompletarCadastroAdComponent} from "../../pages/CompletarCadastroAd/completar-cadastro-ad.component";

const routes: Routes = [
    {path: 'development', component: DevComponent},
    {path: '', component: HomeComponent},
    {path: 'not-found', component: NotFoundComponent},
    {path: 'esqueci-minha-senha', component: EsqueciMinhaSenhaComponent},
    // {path: 'solicitar-cadastro', component: SolicitarCadastroComponent},
    {path: 'perfil', component: PerfilComponent},
    {path: 'login', component: LoginComponent},
    //{path: 'login-externo', component: LoginExternoComponent},
    {path: 'login/validate/:token', component: LoginComponent},
    {path: 'logout/:perfil', component: LoginComponent},
    {path: 'usuario/:id', component: UsuarioComponent},
    {path: 'usuario', component: UsuarioComponent},
    {path: 'cadastro-externo', component: CadastroExternoComponent},
    {path: 'usuario-externo', component: UsuarioExternoComponent},
    {path: 'visualizar-cadastro-externo/:id', component: VisualizarCadastroExternoComponent},
    {path: 'avaliar-cadastro-externo/:id', component: AvaliarCadastroExternoComponent},
    {path: 'usuarios', component: UsuariosComponent},
    {path: 'plano', component: PlanoComponent},
    {path: 'plano/:id', component: PlanoComponent},
    {path: 'planos', component: PlanosComponent},
    {path: 'gerencial', component: GerencialPlanoComponent},
    {path: 'minuta', component: ConsultarMinutaComponent},
    {path: 'execucao-plano/:plano', component: ExecucaoPlanoComponent},
    {path: 'execucao-plano/:plano/:configuracao_grupo_plano', component: ExecucaoPlanoComponent},
    {path: 'completar-cadastro-ad', component: CompletarCadastroAdComponent},
    {path: '**', redirectTo: '/not-found'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})
    ],
    exports: [
        RouterModule
    ]
})

export class RoutingModule {

}
